var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"40px 0"}},[_c('p',{staticStyle:{"font-size":"16px"}},[_vm._v("正在跳转至支付页面，请稍候...")]),(!_vm.applyResult)?_c('p',{staticStyle:{"color":"#f56c6c","margin-top":"10px"}},[_vm._v("跳转链接获取失败，请返回重新发起支付")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }